import React from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookie';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import styles from './BriefDetailsSignUp.module.scss';
import BriefDetailsOnboarding from './BriefDetailsOnboarding';

export default function BriefDetailsSignUp({
  isExternal,
  popularityWarning = false,
}) {
  return (
    <>
      <ListGroup className={styles.container}>
        <ListGroupItem style={{ border: 0 }}>
          <div style={{ padding: '10px 5px' }}>
            <h2 className={styles.heading}>
              {isExternal ? 'Apply' : 'Apply in 1-2 minutes'}
            </h2>
            <hr />
            {popularityWarning && (
              <div className={styles.popularityWarning}>
                {(typeof window !== 'undefined' &&
                  window.location.href.includes('utm_campaign=linkedin_job')) ||
                cookie.load('utm_campaign') === 'linkedin_job' ? (
                  <>Sign up below to apply for this job.</>
                ) : (
                  <>
                    This job has reached its application limit for free
                    accounts. <a href="/pricing/creative">Twine Pro</a> members
                    can still apply.
                  </>
                )}
              </div>
            )}
            <p className={styles.subHeading}>
              <strong>Enter your email to apply</strong>
            </p>
            <BriefDetailsOnboarding
              signUpContainerClass={styles.signUpContainer}
              text="Apply now"
            />
            <p className={styles.helpText}>
              Already have an account? <a href="/signin">Sign in</a>.
            </p>
          </div>
        </ListGroupItem>
      </ListGroup>
    </>
  );
}

BriefDetailsSignUp.propTypes = {
  isExternal: PropTypes.bool,
  popularityWarning: PropTypes.bool,
};
